//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DeltaGap',
  data() {
    return {
      form: {
        serumAlbumin:'',
        na: '',
        cl: '',
        hco: '',
      },
      hasScore: false,
      disabled: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
   computed: {
      /** 计算公式结果 */
      score() {
        let self = this
        let form = JSON.parse(JSON.stringify(self.form))
        let flag = true
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (!form[key]) {
              flag = false
            } else { 
              if (form[key]=='---') {
                flag = false
              } else {  
                form[key] = Number(form[key])
              }
            }
          }
        }
        if (!flag) {
          self.hasScore = false
          return '--'
        } else {  
          let ag = form.na - (form.cl + form. hco)
          let Cag  = ag + 0.25 * (40 - form.serumAlbumin)
          let Xhco = 25 - form.hco
          let Xag = Cag - 12
          let result = {
            value1:(Xag - Xhco).toFixed(2),
            value2:(Xag / Xhco).toFixed(2)
          }
          self.hasScore = true
          return result
        }
      }
    },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DeltaGap.vue